import React from 'react';


const Viewer = ({}) => {
  return (
    <div>
      <iframe
        src="http://localhost:3000/experiences/embed/15f84440-3282-47b6-9a3d-7a3476269481"
        title="10k Web Viewer"
        loading="lazy"
        allowfullscreen=""
        referrerpolicy="no-referrer-when-downgrade"
        style={{ border: "none", width: "600px", height: "400px" }}
      />

      {/* <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d82550.83193340231!2d-122.10259211315055!3d37.852187575821524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808f8ab3332dcf75%3A0x31b62064129d797!2sCastle%20Rock%20Regional%20Recreation%20Area!5e0!3m2!1sen!2sus!4v1741664226760!5m2!1sen!2sus"
        width="600"
        height="450"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe> */}
    </div>
  );
}

export default Viewer;